
import { Outlet} from 'react-router-dom'




function AuthLayout() {
  return (
    <>
    
    <div className="main_dashboard_block">
        <div className="dashboard_wrapper">
          
          <div className="Authoutlet"> 
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthLayout;
